import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pega-cart",
  "use": "pega-cart-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pega-cart\"><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M30.8 9.2a1 1 0 00-.7-.3H8l-.7-5.5a1 1 0 00-1-.8H2a1 1 0 000 1.9h3.7l2.1 16.4a1 1 0 001 .8h19a1 1 0 00.9-.7L31 10a1 1 0 00-.2-.8zm-4 10.6H9.6l-1.2-9H29zM13.5 24.1a2.6 2.6 0 102.7 2.7 2.7 2.7 0 00-2.7-2.7zM23.6 24.1a2.6 2.6 0 102.7 2.7 2.7 2.7 0 00-2.7-2.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol